<template>
  <div class="attendance">
    <div class="loading" v-if="loading">
      <mu-circular-progress :size="60"></mu-circular-progress>
    </div>
    <v-touch :class="['view-btn', { hide: showDetail }]" @swipeleft="swipeLeft">
      <p>查看今日考勤</p>
      <p>
        <mu-icon value="expand_more"></mu-icon>
      </p>
    </v-touch>
    <div :class="['detail-wrapper', { show: showDetail }]">
      <Detail :scheduleList="scheduleList" :getData.sync="showDetail"></Detail>
    </div>
    <div class="title">辰阳永欣考勤系统</div>
    <div class="time">
      当前时间: <span style="color: #ff4081">{{ time }}</span>
    </div>
    <div class="video-wrapper">
      <video id="video" class="video" autoplay></video>
    </div>
    <div class="schedule-list">
      <div
        class="schedule-item"
        v-for="(item, index) in scheduleList"
        :key="index"
      >
        <mu-button
          color="primary"
          class="btn"
          @click="attendanceClick(item, '上班')"
          >{{ item.name }}上班 {{ item.startTime }}</mu-button
        >
        <mu-button
          color="warning"
          class="btn"
          @click="attendanceClick(item, '下班')"
          >{{ item.name }}下班 {{ item.endTime }}</mu-button
        >
      </div>
    </div>
    <canvas style="display: none" id="canvas"></canvas>
  </div>
</template>

<script>
import moment from 'moment'
import backend from 'utils/backend'
import api from '@/api'
import Detail from './attendance-detail'
export default {
  components: { Detail },
  data() {
    return {
      time: moment().format('MM-DD HH:mm:ss'),
      scheduleList: [],
      moment,
      loading: false,
      showDetail: false
    }
  },
  methods: {
    cameraInit() {
      const video = document.getElementById('video')
      navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
        video.srcObject = stream
      })
    },
    timeInit() {
      this.time = moment().format('MM-DD HH:mm:ss')
    },
    getAllSchedule() {
      backend(api.daka.getSchedule, { getAll: true, isUsing: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            // 过滤启用的，按开始时间排序
            this.scheduleList = result.data.rows.sort(
              (a, b) =>
                Number(a.startTime.split(':')[0]) -
                Number(b.startTime.split(':')[0])
            )
          }
        }
      )
    },
    attendanceClick(schedule, type) {
      if (type === '下班' && !schedule.isOvertime) {
        if (moment().isBefore(moment(schedule.endTime, 'HH:mm:ss'))) {
          this.$confirm('下班时间未到，确定要打卡？', '提示', {
            type: 'warning'
          }).then(({ result }) => {
            if (result) {
              this.attendance(schedule, type)
            }
          })
        } else {
          this.attendance(schedule, type)
        }
      } else {
        this.attendance(schedule, type)
      }
    },
    attendance(schedule, type) {
      this.loading = true
      const base64 = this.takePhoto()
      backend(api.daka.daka, { schedule, type, base64 }).then((result) => {
        this.loading = false
        if (result.statusCode === 200) {
          this.$toast.success(result.msg)
        } else {
          this.$toast.error(result.msg)
        }
      })
    },
    takePhoto() {
      const canvas = document.getElementById('canvas')
      const video = document.getElementById('video')
      const context = canvas.getContext('2d')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      context.drawImage(video, 0, 0)
      return canvas
        .toDataURL('image/jpg')
        .replace(/^data:image\/\w+;base64,/, '')
    },
    swipeLeft() {
      console.log('left')
      this.showDetail = true
    }
  },
  mounted() {
    setInterval(() => {
      this.timeInit()
    }, 1000)
    this.cameraInit()
    this.getAllSchedule()
  }
}
</script>

<style lang="less" scoped>
.attendance {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    background: hsla(0, 0%, 100%, 0.9);
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title {
    font-size: 30px;
    text-align: center;
  }
  .time {
    font-size: 20px;
    text-align: center;
  }
  .video-wrapper {
    height: calc(100% - 240px);
    .video {
      height: 100%;
      width: 100%;
    }
  }
  .schedule-list {
    width: 600px;
    flex: 0 0 144px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px 0;
    .schedule-item {
      width: 100%;
      margin: 6px 0;
      display: flex;
      justify-content: space-around;
      .btn {
        width: 200px;
      }
    }
  }
  .view-btn {
    position: absolute;
    right: 6px;
    writing-mode: vertical-rl;
    height: 120px;
    text-align: center;
    line-height: 16px;
    transition: all 1s;
    top: 50%;
    margin-top: -60px;
    background: rgba(255, 255, 255, 0.1);
    &.hide {
      right: calc(100vw + 40px);
    }
  }
  .detail-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    background: hsla(0, 0%, 100%, 0.9);
    top: 0;
    right: -100%;
    z-index: 10;
    transition: all 1s;
    &.show {
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/attendance.vue